__turbopack_context__.v({
  "close": "Titlebar-module__R7frfW__close",
  "items": "Titlebar-module__R7frfW__items",
  "maximize": "Titlebar-module__R7frfW__maximize",
  "menuItem": "Titlebar-module__R7frfW__menuItem",
  "minimize": "Titlebar-module__R7frfW__minimize",
  "title": "Titlebar-module__R7frfW__title",
  "titlebar": "Titlebar-module__R7frfW__titlebar",
  "windowButtons": "Titlebar-module__R7frfW__windowButtons",
});
